import { mapGetters } from 'vuex';
import { getField, isFieldEnabled } from 'widget/helpers/utils';

export default {
  computed: {
    ...mapGetters({
      webChannelConfig: 'appConfig/getWebChannelConfig',
      hiverConfig: 'hiverConfig/getHiverConfig'
    }),
    hasAConnectedAgentBot() {
      return this.hiverConfig.is_workflow_enabled;
    },
    hasConnectedAgentBot() {
      return this.webChannelConfig?.hasAConnectedAgentBot || '';
    },
    inboxAvatarUrl() {
      return this.webChannelConfig.avatarUrl;
    },
    channelConfig() {
      return this.webChannelConfig;
    },
    hasEmojiPickerEnabled() {
      return this.channelConfig.enabledFeatures.includes('emoji_picker');
    },
    hasAttachmentsEnabled() {
      return this.channelConfig.enabledFeatures.includes('attachments');
    },
    preChatFormEnabled() {
      return this.webChannelConfig.preChatFormEnabled;
    },
    hiverDefaultBotName() {
      return 'Bot';
    },
    hiverDefaultBotType() {
      return 'agent_bot';
    },
    isLiveChatFeatureEnabled() {
      return this.hiverConfig.live_chat_customisation_feature_access;
    },
    isPreChatCountryCodeEnabled() {
      return this.hiverConfig.prechat_country_code_feature_access;
    },
    isNotificationSoundDisabled() {
      return this.hiverConfig.disable_widget_notifications;
    },
    isSurfaceKBInLiveChatEnabled() {
      const { surface_kb_feature_access, knowledge_base = {} } = this.hiverConfig || {};
      return (
          surface_kb_feature_access &&
          knowledge_base?.enabled &&
          knowledge_base?.id
      );
    },
    preChatFormOptions() {
      let enabledFields = {
        emailAddress: false,
        fullName: false,
        phoneNumber: false,
        preChatMessage: true
      };
      let preChatMessage = '';
      const options = this.webChannelConfig.preChatFormOptions || {};
      const preChatFields = (options && options.pre_chat_fields) || [];

      const emailField = getField(preChatFields, 'emailAddress');
      const fullNameField = getField(preChatFields, 'fullName');
      const phoneNumberField = getField(preChatFields, 'phoneNumber');

      if (!this.isOnNewConversation) {
        enabledFields = {
          emailAddress: isFieldEnabled(emailField),
          fullName: isFieldEnabled(fullNameField),
          phoneNumber: isFieldEnabled(phoneNumberField),
          preChatMessage: !this.hasAConnectedAgentBot
        };
        preChatMessage = options.pre_chat_message;
      }

      return {
        enabledFields,
        requiredFields: {
          emailAddress: true,
          fullName: true,
          phoneNumber: true
        },
        preChatMessage
      };
    }
  }
};
